import MuiAvatarGroup from '@mui/material/AvatarGroup';

import { styled } from 'helpers';

import { Props } from './types';

export const AvatarGroup = styled(MuiAvatarGroup, {
  shouldForwardProp: (prop) => prop !== 'size',
})<Props>`
  display: inline-flex;
  height: ${({ size }) => size}px;

  > .MuiAvatarGroup-avatar {
    height: ${({ size }) => size}px;
    font-size: ${({ size, theme }) => {
      const fontSizeMap: { [s: number]: number } = {
        24: 8,
        32: 10,
        48: 14,
        56: 16,
        88: 24,
        120: 32,
      };
      return size ? theme.typography.pxToRem(fontSizeMap[size]) : '';
    }};
    width: ${({ size }) => size}px;
  }
`;

export default AvatarGroup;
